"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MessageInput = function MessageInput() {
  return /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageInput, null);
};
var _default = MessageInput;
exports.default = _default;